export const DragableTypes = {
    ARTWORK: 'artwork',
    TRACK_ARTWORK: 'track-artwork',
    PLAIN_TOOL: 'plain-tool'
}
